document.addEventListener('DOMContentLoaded',()=>{const toggle=document.querySelector('.mobile-toggle'),menu=document.querySelector('.mobile-menu');if(toggle&&menu){toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!open));menu.hidden=open;});}const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('visible');observer.unobserve(entry.target);}})},{threshold:.1});document.querySelectorAll('.reveal').forEach(el=>observer.observe(el));});
/* Motion is progressively enhanced; Shopify theme editor reloads are supported. */
(()=>{let ticking=false;const reduce=matchMedia('(prefers-reduced-motion: reduce)');function animate(){ticking=false;if(reduce.matches)return;const h=innerHeight;document.querySelectorAll('[data-parallax]').forEach(el=>{const r=el.parentElement.getBoundingClientRect();if(r.bottom<0||r.top>h)return;const speed=Math.min(.25,Math.max(0,parseFloat(el.dataset.parallax)||0));el.style.transform=`translate3d(0,${Math.round((h/2-(r.top+r.height/2))*speed)}px,0)`;});}function request(){if(!ticking){ticking=true;requestAnimationFrame(animate)}}function setup(){const ob=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('visible');ob.unobserve(e.target)}})},{threshold:.08});document.querySelectorAll('.reveal:not(.visible)').forEach(el=>ob.observe(el));document.querySelectorAll('video[autoplay]').forEach(v=>{v.muted=true;v.playsInline=true;v.setAttribute('muted','');v.play().catch(()=>{});});request()}document.addEventListener('DOMContentLoaded',setup);document.addEventListener('shopify:section:load',setup);addEventListener('scroll',request,{passive:true});addEventListener('resize',request,{passive:true});})();

/* Pointer-responsive 2.5D bottle layers, scroll parallax, and reduced-motion support. */
(()=>{const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');let raf=0;function update(){raf=0;document.querySelectorAll('[data-immersive-section]').forEach(section=>{const rect=section.getBoundingClientRect();if(rect.bottom<0||rect.top>innerHeight)return;const stage=section.querySelector('[data-tilt-stage]');if(!stage)return;const progress=(innerHeight/2-(rect.top+rect.height/2))/Math.max(rect.height,1);section.querySelectorAll('[data-float-layer]').forEach((layer,i)=>{const depth=Number(layer.dataset.depth)||3;layer.style.setProperty('--float-y',`${Math.round(progress*depth*24+Math.sin(performance.now()/1700+i*2)*6)}px`);layer.style.setProperty('--float-x',`${Math.round(progress*depth*(i%2?8:-7))}px`)});});}
function frame(){if(!raf)raf=requestAnimationFrame(update)}function init(root=document){root.querySelectorAll('[data-tilt-stage]').forEach(stage=>{if(stage.dataset.immersiveReady)return;stage.dataset.immersiveReady='true';stage.addEventListener('pointermove',e=>{if(reduced.matches||e.pointerType==='touch')return;const r=stage.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;stage.querySelectorAll('[data-float-layer]').forEach(layer=>{layer.style.setProperty('--tilt-x',`${(-y*8).toFixed(2)}deg`);layer.style.setProperty('--tilt-y',`${(x*11).toFixed(2)}deg`)});},{passive:true});stage.addEventListener('pointerleave',()=>stage.querySelectorAll('[data-float-layer]').forEach(layer=>{layer.style.setProperty('--tilt-x','0deg');layer.style.setProperty('--tilt-y','0deg')}));});if(!reduced.matches)frame()}
document.addEventListener('DOMContentLoaded',()=>init());document.addEventListener('shopify:section:load',e=>init(e.target));addEventListener('scroll',()=>{if(!reduced.matches)frame()},{passive:true});addEventListener('resize',frame,{passive:true});reduced.addEventListener('change',()=>{document.querySelectorAll('[data-float-layer]').forEach(el=>{el.style.removeProperty('--float-x');el.style.removeProperty('--float-y')});if(!reduced.matches)frame()});})();

/* PERFURISSIMO — NEXT PAGE BUTTON */
(function () {
  function setupPages() {
    document.querySelectorAll(
      'pf-catalog-v3, pf-catalog-v4'
    ).forEach(function (catalog) {
      if (catalog.dataset.pfNextReady === 'yes') return;

      var grid = catalog.querySelector('[data-grid]');
      if (!grid) return;

      catalog.dataset.pfNextReady = 'yes';

      var page = 1;
      var perPage = 12;

      var nav = document.createElement('div');
      nav.className = 'pf-simple-next';

      nav.style.cssText =
        'display:flex;justify-content:center;' +
        'align-items:center;gap:15px;' +
        'padding:35px 10px;';

      var prev = document.createElement('button');
      var counter = document.createElement('span');
      var next = document.createElement('button');

      prev.textContent = '← PREVIOUS';
      next.textContent = 'NEXT →';

      [prev, next].forEach(function (button) {
        button.type = 'button';
        button.style.cssText =
          'background:#111;color:#fff;' +
          'border:1px solid #111;' +
          'padding:13px 20px;' +
          'font-size:12px;cursor:pointer;';
      });

      counter.style.cssText =
        'font-size:13px;color:#111;';

      nav.append(prev, counter, next);
      grid.after(nav);

      function update() {
        var cards = Array.from(grid.children).filter(
          function (el) {
            return el.classList.contains('pf-card');
          }
        );

        var total = Math.ceil(cards.length / perPage);

        if (page > total) page = Math.max(1, total);

        cards.forEach(function (card, index) {
          card.style.display =
            index >= (page - 1) * perPage &&
            index < page * perPage
              ? ''
              : 'none';
        });

        counter.textContent =
          page + ' / ' + Math.max(1, total);

        prev.disabled = page <= 1;
        next.disabled = page >= total;

        prev.style.opacity = prev.disabled ? '.35' : '1';
        next.style.opacity = next.disabled ? '.35' : '1';

        nav.style.display = total > 1 ? 'flex' : 'none';
      }

      function goTo(newPage) {
        page = newPage;
        update();

        catalog.querySelector('.pf-results')
          .scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
      }

      prev.addEventListener('click', function () {
        if (page > 1) goTo(page - 1);
      });

      next.addEventListener('click', function () {
        goTo(page + 1);
      });

      var observer = new MutationObserver(function () {
        page = 1;
        update();
      });

      observer.observe(grid, { childList: true });

      update();
    });
  }

  document.addEventListener(
    'DOMContentLoaded',
    setupPages
  );

  document.addEventListener(
    'shopify:section:load',
    setupPages
  );

  setupPages();
})();
